import { nanoid } from 'nanoid';

export const randomIdentifier = (): string => { 
  return nanoid()
}
